import { get } from "../util/request";

export const getListProvince = () => {
  return get("/platform/website/region/list-province");
};
export const getListCity = (provinceId) => {
  return get(`/platform/website/region/list-city/${provinceId}`);
};
export const getListArea = (cityId) => {
  return get(`/platform/website/region/list-district/${cityId}`);
};




// WEBPACK FOOTER //
// ./src/api/region.js